import React, { ChangeEvent } from "react";
import { useField, Field } from "formik";
import AppCheckbox, { AppCheckboxProps } from "src/commun/composants/formulaire/AppCheckbox/AppCheckbox";

export type AppCheckboFormikProps = Omit<AppCheckboxProps, "onChange" | "error"> & {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const AppCheckboxFormik = ({ name, onChange, ...reste }: AppCheckboFormikProps) => {
  const [, { value, error }, { setValue, setTouched }] = useField(name);

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setTouched(true);
    setValue(`${event.target.checked}`); // Checkbox value est de type string
    if (onChange) onChange(event);
  };

  return (
    <Field
      type="checkbox"
      name={name}
      error={error}
      onChange={changeHandler}
      as={AppCheckbox}
      checked={value === "true" || value === true}
      {...reste} />
  )
};

export default AppCheckboxFormik;
